export const ORDER_DENTAL = 'dental-order';
export const ORDER_EXAM = 'dental-exam';
export const DENTAL_CASE = 'dental-case';

export default {
  ORDER_DENTAL,
  ORDER_EXAM,
  DENTAL_CASE
};
